export default "__VITE_ASSET__DMy4K_8Q__"